import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation'
import { Tooltip } from 'antd'
import { dateParse } from 'helpers/date.helper'
import { Wrapper } from './styled'

interface IProps {
  value: string
  active: boolean
}

const CreatedAt = ({ value, active }: IProps) => {
  const { t } = useTranslation()
  const translatePrefix = 'administration.certificate.list.create'

  return (
    <Wrapper>
      {dateParse(value, 'dd-MM-yyyy hh:mm')}
      {!active && (
        <Tooltip
          title={t(`${translatePrefix}.table.headers.certificateDisabled`)}
          placement="bottom"
        >
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </Tooltip>
      )}
    </Wrapper>
  )
}

export default CreatedAt
